// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__2QQbi","text":"Toggle_text__1G2u8","track":"Toggle_track__1thET","checked":"Toggle_checked__3z3E-","indicator":"Toggle_indicator__3hk1o"};